module.exports = __webpack_public_path__ + "img/payments-white.f7020667.svg";